import { useMemo } from 'react';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useProductEntitlementDetails } from '@atlassian/jira-tenant-context-controller/src/components/product-entitlement-details';

export const useIsEnrolledInExperience = () => {
	const productEntitlementDetails = useProductEntitlementDetails();

	const isInTrial = useMemo(() => {
		const supportedProducts = ['jira-software', 'jira-product-discovery', 'jira-servicedesk'];
		let trialing = false;

		if (productEntitlementDetails) {
			Object.keys(productEntitlementDetails).forEach((product) => {
				if (supportedProducts.includes(product) && productEntitlementDetails[product].trialEndTime)
					trialing = true;
			});
		}
		return trialing;
	}, [productEntitlementDetails]);

	if (!isInTrial && expValEquals('jsw_rovo_demand_tests_page', 'cohort', 'test')) {
		return true;
	}

	return false;
};
